export const Method = () => (
  <section id="method" data-testid="method-section" className="py-24 px-6 md:px-12 max-w-6xl mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-5 grid grid-cols-2 gap-4">
        <div className="rounded-xl overflow-hidden aspect-[3/4] border border-cream relative">
          <img
            src="https://images.pexels.com/photos/29821661/pexels-photo-29821661.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            alt="Visceral abdominal manipulation technique"
            className="absolute inset-0 w-full h-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-x-0 bottom-0 flex items-end p-3 bg-gradient-to-t from-black/50 to-transparent h-full">
            <span className="font-monolbl text-[10px] text-white/90 uppercase tracking-widest bg-black/40 px-2 py-1 rounded">
              Visceral Layer
            </span>
          </div>
        </div>
        <div className="rounded-xl overflow-hidden aspect-[3/4] border border-cream mt-6 relative">
          <img
            src="https://images.unsplash.com/photo-1741522509438-a120c0bb5e88?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxtYXNzYWdlJTIwdGhlcmFwaXN0JTIwd29ya2luZ3xlbnwwfHx8fDE3OTIyNDYyMzZ8MA&ixlib=rb-4.1.0&q=85"
            alt="Precision lymphatic drainage strokes"
            className="absolute inset-0 w-full h-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-x-0 bottom-0 flex items-end p-3 bg-gradient-to-t from-black/50 to-transparent h-full">
            <span className="font-monolbl text-[10px] text-white/90 uppercase tracking-widest bg-black/40 px-2 py-1 rounded">
              Lymph Drainage
            </span>
          </div>
        </div>
      </div>

      <div className="lg:col-span-7">
        <span className="font-monolbl text-xs uppercase tracking-[0.2em] text-forest font-semibold">
          The Dual Science
        </span>
        <h2 className="font-display text-3xl md:text-5xl tracking-tight text-ink mt-3 mb-6">
          Why visceral manual therapy changes the lymphatic outcome.
        </h2>
        <p className="text-sage text-base md:text-lg leading-relaxed mb-6">
          Standard lymphatic drainage only skims superficial tissue. LymphoMetabolic combines
          deep visceral manipulation to release organ tension with gentle nodal drainage,
          unlocking metabolic stagnation at the root.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-4 border-t border-cream">
          <div>
            <h3 className="font-display text-xl text-ink font-semibold mb-1">
              Visceral Decompression
            </h3>
            <p className="text-sm text-moss">
              Frees the diaphragm and abdomen so deep cisterns drain naturally.
            </p>
          </div>
          <div>
            <h3 className="font-display text-xl text-ink font-semibold mb-1">
              Metabolic Acceleration
            </h3>
            <p className="text-sm text-moss">
              Promotes systemic detox, reduced fluid retention, and cellular tone.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);
